import { styled } from '@linaria/react'

export const Wrapper = styled.div``

export const InnerWrapper = styled.div`
  padding: ${({ isImage }) => (isImage ? '45px 41% 45px 50px' : '45px 50px')};
  background: var(--white);
  box-shadow: 0px 4px 22px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  overflow: hidden;
  position: relative;

  @media screen and (max-width: 768px) {
    padding: ${({ isImage }) =>
      isImage ? 'calc(60% + 25px) 20px 20px 20px' : '30px 20px'};
  }

  .dhsv-button {
    margin-top: 2rem;
    margin-bottom: 0;

    @media screen and (max-width: 768px) {
      margin-top: 1.2rem;
    }
  }
`

export const Index = styled.div`
  color: var(--primary);
  font-size: var(--font-size-index);
  font-weight: var(--font-weight-bold);
  margin-bottom: 0.5rem;
`

export const Title = styled.h2`
  color: var(--primary);
  padding: 0;
  margin-bottom: 2.2rem;
`

export const Text = styled.div`
  color: var(--primary);
`

export const Image = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 37%;

  @media screen and (max-width: 768px) {
    height: auto;
    width: 100%;
    padding-bottom: 60%;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(var(--clr-primary), 0.2);
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`
